export default {"src":"/_next/static/media/blue-select.eaa9ad6a.svg","height":25,"width":120,"blurWidth":0,"blurHeight":0};